import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useLabResultsStore } from '../../store/lab-results-store';

interface Props {
  successUrl?: string
}

type Input = {
  file: FileList
}

export const LabResultCSVUploadForm: React.FC<Props> = ({ successUrl }: Props) => {
  const navigate = useNavigate();
  const {
    register, handleSubmit, formState: { errors, isSubmitting },
  } = useForm<Input>();
  const uploadLabResultByCSV = useLabResultsStore((state) => state.uploadLabResultByCSV);
  const serverError = useLabResultsStore((state) => state.serverError);
  const onSubmit = async (data: Input) => {
    const file = data.file[0];
    await uploadLabResultByCSV(file);
    if (successUrl) {
      navigate(successUrl);
    }
  };

  const requiredFieldErrorMessage = 'This field is required';

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {serverError && <p className="mb-8">{serverError}</p>}
      <fieldset>
        <div>
          <input
            type="file"
            {...register('file', {
              required: requiredFieldErrorMessage,
            })}
          />
        </div>
        <div>
          {errors.file && <span>{errors.file.message}</span>}
        </div>
      </fieldset>
      <fieldset className="flex flex-row mt-6">
        <button
          type="submit"
          disabled={isSubmitting}
          className="flex-1 hover:bg-[#aaaaaa] shadow-lg p-4 text-xl rounded-lg transition duration-150"
        >
          {/* Update to official spinner later */}
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </fieldset>
    </form>
  );
};

LabResultCSVUploadForm.defaultProps = {
  successUrl: '/lab-results',
};
